import { createContext, useState } from "react";
import Cookies from "js-cookie";
import { getVerifyToken } from "../helpers/login.helper";
import { clearSessionToken, setSessionToken } from "../api/API";

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [userInfoQursiva, setUserInfoQursiva] = useState(() => {
    const raw = localStorage.getItem("userInfoQursiva");
    if (!raw) return false;
    try {
      const parsed = JSON.parse(raw);
      // Rehidratar token en memoria en el mount — asi queries disparadas
      // antes de que el context propague tienen token disponible.
      if (parsed && parsed.tokenQursiva) setSessionToken(parsed.tokenQursiva);
      return parsed;
    } catch {
      return false;
    }
  });
  const [isLogged, setIsLogged] = useState(
    Object.entries(userInfoQursiva).length > 0 ? true : false
  );
  const [filterCourse, setFilterCourse] = useState({
    typeFilter: 0,
    idFilter: 0,
  });
  const [topicActiv, setTopicActiv] = useState({});
  const [isPlaying, setIsPlaying] = useState({
    id: 0,
    sonPosition: 0,
    fatherPosition: 0,
  });
  const [fatherIsPlaying, setFatherIsPlaying] = useState();

  const logOut = ({ unAuthorized, navigateTo = "/" }) => {
    clearSessionToken();
    localStorage.removeItem("userInfoQursiva");
    localStorage.removeItem("iboInfo");
    localStorage.removeItem("contact");
    Cookies.remove("user-tk");
    setIsLogged(false);
    setUserInfoQursiva(false);
    if (unAuthorized && window.location.pathname !== navigateTo) {
      window.location.href = navigateTo;
    }
  };

  const getUserLocalStorage = () => {
    const userInfo = JSON.parse(localStorage.getItem("userInfoQursiva"));
    const iboInfo = JSON.parse(localStorage.getItem("iboInfo"));

    if (userInfo) {
      return userInfo;
    } else if (iboInfo) {
      return iboInfo;
    } else {
      return false;
    }
  };

  const isLoggedValidate = async ({ navigateTo }) => {
    const user = getUserLocalStorage();
    if (!user) {
      return;
    }
    const sesion = await getVerifyToken(user.tokenQursiva);
    if (!sesion) {
      logOut({ unAuthorized: true, navigateTo });
    }
  };

  return (
    <AuthContext.Provider
      value={{
        logOut,
        topicActiv,
        setTopicActiv,
        userInfoQursiva,
        setUserInfoQursiva,
        isLogged,
        setIsLogged,
        filterCourse,
        setFilterCourse,
        isPlaying,
        setIsPlaying,
        fatherIsPlaying,
        setFatherIsPlaying,
        isLoggedValidate,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
